import logo from './logo.svg';
import './App.css';
import Nav from './components/nav';

function App() {
  return (
    <Nav/>
  );
}

export default App;
